export default [
    {
        path: '/c/:company_id/pos/',
        name: 'pos',
        component: () => import('@/views/order/pos/index.vue'),
        meta: {
            layout: 'content',
            resource: 'PosOrder',
            action: 'read'
        },
    },
    {
        path: '/c/:company_id/pos/device',
        name: 'pos_device',
        component: () => import('@/views/order/pos/device.vue'),
        meta: {
            layout: 'content',
            resource: 'PosOrder',
            action: 'update'
        },
    },
    {
        path: '/c/:company_id/pos/device/:device_id',
        name: 'posorder_create',
        component: () => import('@/views/order/pos/create.vue'),
        meta: {
            layout: 'blank',
            resource: 'PosOrder',
            action: 'update'
        },
    },
    {
        path: '/c/:company_id/pos/device/:device_id/order/:posorder_id',
        name: 'posorder_viewer',
        component: () => import('@/views/order/pos/viewer.vue'),
        meta: {
            layout: 'content',
            resource: 'PosOrder',
            action: 'read'
        },
    },
]
